/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
import { ThemeProvider } from "@material-ui/styles";
import IconButton from "@material-ui/core/IconButton";
import theme from "../../../../Themes/defaultTheme";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    transition: "color 0.2s ease, background-color 0.2s ease",
  },
  primary: {
    color: "var(--color-primary-main) !important",
  },
  secondary: {
    color: "var(--color-secondary-main) !important",
  },
  default: {
    color: "var(--color-text-primary) !important",
  }
}));

const A_IconButton = (props) => {
  const classes = useStyles();
  
  const getColorClass = () => {
    switch (props.color) {
      case "primary": return classes.primary;
      case "secondary": return classes.secondary;
      case "default": return classes.default;
      default: return "";
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <IconButton
        style={props.style}
        aria-label={props.ariaLabel || "icon button"}
        component={props.component || "span"}
        color={props.color === "white" ? "default" : props.color}
        size={props.size}
        disabled={props.disabled}
        onClick={props.onClick}
        onDoubleClick={props.onDoubleClick}
        className={`${classes.root} ${getColorClass()} ${props.className || ""}`}
      >
        {props.icon}
      </IconButton>
    </ThemeProvider>
  );
};
A_IconButton.defaultProps = {
  color: "primary",
  size: "medium",
};
A_IconButton.propTypes = {
  color: PropTypes.oneOf(["default", "inherit", "primary", "secondary", "white"]),
  size: PropTypes.oneOf(["small", "medium"]),
  icon: PropTypes.element,
  ariaLabel: PropTypes.string,
  component: PropTypes.elementType,
  onClick: PropTypes.func,
  onDoubleClick: PropTypes.func,
};
export default A_IconButton;
